import {
  Box,
  Kbd,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useReducedMotion } from "framer-motion";

type KeyboardShortcutsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SHORTCUTS: { keys: string[]; description: string }[] = [
  { keys: ["p", "←"], description: "Previous inference" },
  { keys: ["n", "→"], description: "Next inference" },
  { keys: ["v"], description: "Mark as valid" },
  { keys: ["i"], description: "Mark as invalid" },
  { keys: ["f"], description: "Flag detection" },
  { keys: ["c"], description: "Toggle composite mode" },
  { keys: ["Esc"], description: "Return to scene page" },
];

function KeyboardShortcutsModal({ isOpen, onClose }: KeyboardShortcutsModalProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      motionPreset={prefersReducedMotion ? "none" : "scale"}
    >
      <ModalOverlay />
      <ModalContent overscrollBehavior="contain">
        <ModalHeader>Keyboard Shortcuts</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} overscrollBehavior="contain">
          <Box display="flex" flexDir="column" gap="3">
            {SHORTCUTS.map(({ keys, description }) => (
              <Box
                key={description}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                fontSize="sm"
              >
                <Text opacity="0.875">{description}</Text>
                <Box display="flex" gap="1">
                  {keys.map((key) => (
                    <Kbd key={key}>{key}</Kbd>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default KeyboardShortcutsModal;
